var _rect, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopySuccess = function SvgCopySuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#33CC99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2556 22.0046C13.9407 22.0332 13.6545 21.8042 13.3683 21.518C12.9962 21.1459 12.6241 20.7452 12.252 20.3731C11.8227 19.9437 11.3933 19.4858 10.964 19.0564C10.4488 18.5412 9.93357 17.9974 9.41836 17.4822C9.01764 17.0815 8.61693 16.7094 8.24483 16.2801C7.90136 15.8793 7.90136 15.1638 8.35932 14.7917C8.87453 14.3623 9.44698 14.4768 9.90494 14.9634C10.2484 15.3641 10.6205 15.7076 10.9926 16.0797C11.4792 16.5663 11.9371 17.0529 12.4237 17.5394C12.8817 17.9974 13.311 18.4554 13.769 18.9133C13.8835 19.0278 14.0266 19.1709 14.1411 19.2854C14.227 19.3999 14.3128 19.4285 14.4273 19.2854C14.8853 18.7988 15.3432 18.3695 15.8012 17.8829C16.2592 17.425 16.7171 16.9384 17.1751 16.4804C17.7762 15.8793 18.3772 15.2783 18.9783 14.6486C19.5508 14.0761 20.0946 13.475 20.667 12.9026C21.2109 12.3588 21.7547 11.8149 22.2985 11.2711C22.6134 10.9562 22.9282 10.6128 23.2431 10.2979C23.6152 9.92583 24.2449 9.89721 24.617 10.2407C25.0177 10.5842 25.0463 11.0135 24.9604 11.3856C24.8746 11.6718 24.7028 11.8149 24.5311 11.9867C24.1018 12.4446 23.6724 12.874 23.2431 13.3033C22.871 13.6754 22.4989 14.0475 22.1268 14.4196C21.6688 14.8775 21.2109 15.3641 20.7529 15.8221C20.1805 16.3945 19.608 16.967 19.0642 17.5394C18.2914 18.3409 17.5186 19.1423 16.7457 19.9437C16.1733 20.5162 15.6008 21.1173 15.0284 21.6897C14.828 21.9187 14.5704 22.0046 14.2556 22.0046Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(5.33337 5.33325)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopySuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copySuccess.4fb17bcd.svg";
export { ForwardRef as ReactComponent };